<template>
  <Modal
    v-if="shown"
    :title="titleText"
    @close="show(false)"
    :close-on-click-outside="false"
    :width="modalType === 'startShipment' ? 650 : 1000"
  >
    <template v-slot:body>
      <template v-if="modalType !== 'startShipment'">
        <div class="flex flex_between md-group">
          <md-button
            class="flex_1"
            :class="{ 'md-primary': activeType === activeTypes.salesContract }"
            @click="changeActiveType(activeTypes.salesContract)"
          >
            {{ $t("trackPay.contractsEditModal.salesContract") }}
          </md-button>
          <md-button
            class="flex_1"
            :class="{ 'md-primary': activeType === activeTypes.shipment }"
            @click="changeActiveType(activeTypes.shipment)"
          >
            {{ $t("trackPay.contractsEditModal.shipment") }}
          </md-button>
          <md-button
            class="flex_1"
            :class="{ 'md-primary': activeType === activeTypes.trackers }"
            @click="changeActiveType(activeTypes.trackers)"
          >
            {{ $t("trackPay.contractsTable.trackers") }}
          </md-button>
          <md-button
            class="flex_1"
            :class="{ 'md-primary': activeType === activeTypes.process }"
            @click="changeActiveType(activeTypes.process)"
          >
            {{ $t("trackPay.contractsEditModal.contractAddProcess") }}
          </md-button>
        </div>
        <SalesContractForm
          v-show="activeType === activeTypes.salesContract"
          :contract-data="contractData"
          :readOnly="readOnly"
          :isEditMode="modalType === 'edit'"
          ref="SalesContractForm"
          @next="changeActiveType(activeTypes.shipment)"
          @close="show(false)"
        ></SalesContractForm>
        <ShipmentForm
          v-show="activeType === activeTypes.shipment"
          ref="ShipmentForm"
          :readOnly="readOnly"
          :contract-data="contractData"
          :trackerForm="$refs.TrackersForm"
          :isEditMode="modalType === 'edit'"
          @back="changeActiveType(activeTypes.salesContract)"
          @next="changeActiveType(activeTypes.trackers)"
          @close="show(false)"
          @onSelectCountry="onSelectCountry"
        ></ShipmentForm>
        <TrackersForm
          v-show="activeType === activeTypes.trackers"
          :contract-data="contractData"
          :isEditMode="modalType === 'edit'"
          ref="TrackersForm"
          @back="changeActiveType(activeTypes.shipment)"
          @next="changeActiveType(activeTypes.process)"
          :readOnly="readOnly"
          @close="show(false)"
          :class="contractData.rejectReason ? 'has_reason' : ''"
        ></TrackersForm>
        <Process
          v-show="activeType === activeTypes.process"
          :contract-data="contractData"
          :salesForm="$refs.SalesContractForm"
          :shipmentForm="$refs.ShipmentForm"
          :trackerForm="$refs.TrackersForm"
          ref="Process"
          @back="changeActiveType(activeTypes.trackers)"
          @close="show(false)"
          :readOnly="readOnly"
          @save="save"
        ></Process>
      </template>
      <ContractsStartShipment
        v-if="modalType === 'startShipment'"
        :contract-data="contractData"
        @close="show(false)"
        @start="save"
      ></ContractsStartShipment>
    </template>
  </Modal>
</template>

<script>
import Modal from "src/components/templates/modal/Modal";
import ShipmentForm from "@/components/templates/trackPay/ShipmentForm";
import SalesContractForm from "@/components/templates/trackPay/SalesContractForm";
import TrackersForm from "@/components/templates/trackPay/TrackersForm";
import Process from "@/components/templates/trackPay/Process";
import moment from "moment";
import {enumDef} from "@/common/enumDefs";
import ContractsStartShipment from "./ContractsStartShipment";
import {trackPayApi} from "src/common/api/trackPayApi";

export default {
  components: {
    ShipmentForm,
    Modal,
    SalesContractForm,
    TrackersForm,
    Process,
    ContractsStartShipment,
  },
  data() {
    let activeTypes = {
      salesContract: "salesContract",
      shipment: "shipment",
      trackers: "trackers",
      process: "process",
    };

    return {
      editMode: false,
      shown: false,
      activeTypes: activeTypes,
      activeType: activeTypes.salesContract,
      contractData: {
        country: "",
      },
      modalType: "add",
      readOnly: false,
    };
  },
  computed: {
    titleText() {
      let title = this.$t("trackPay.contracts.editNewContract");
      if (this.modalType === "add") {
        title = this.$t("trackPay.contractsEditModal.title");
      }
      if (this.modalType === "viewDetail") {
        title = this.$t("trackPay.contracts.viewDetail");
      }
      if (this.modalType === "startShipment") {
        title = this.$t("common.data.contractsStatus.startShipment");
      }
      return title;
    },
  },
  methods: {
      onSelectCountry(data) {
        this.$refs.TrackersForm.form.isLocation = data && data === "DE";
      },
    save(type) {
      let option = {};
      const { trackPayStats } = enumDef;

      if (type === "start") {
        option = this.contractData;
      } else {
        let shipmentDetails = this.$refs.ShipmentForm.getData();
        let trackers = this.$refs.TrackersForm.getData();
        let salesContract = this.$refs.SalesContractForm.getData();
        let deviceProfileId = JSON.parse(JSON.stringify(trackers.shipment.deviceProfileId));
        Object.assign(option, salesContract, shipmentDetails, trackers);
        Object.assign(option.shipment, salesContract.shipment, shipmentDetails.shipment)

		option.shipment.estimatedDeliveryDate = salesContract.shipment.estimatedDeliveryDate;
        option.shipment.deliveryDateTolerance = salesContract.shipment.deliveryDateTolerance;
        option.shipment.deviceProfileId = deviceProfileId;
		option.shipment.productDescription = shipmentDetails.shipment.productDescription
        option.shipment.selectedModesOfTransport = shipmentDetails.modesOfTransport.filter(m => m.vModel === true).map(m => m.key)
        option.id = this.contractData.id;

        let localeUser = this.$sessionStorage.get("localeUser");
        option.supplier = {id: localeUser.companyId};
        option.userId = localeUser.userId;
        option.shipment.completed = false;
        option.shipment.orderDevices = shipmentDetails.shipment.orderDevices;

        option.feeObligatory = this.$refs.Process.getFeeObligatory()
      }

      if (type === "save" || type === "saveAndSend") {
        option.status = trackPayStats.New;
      }
      if (type === "send") {
        option.status = trackPayStats.Submitted;
      }

      if (this.contractData && !this.contractData.id) {
        option.id = moment().format("x");
      }

      if (this.modalType === "startShipment") {
        trackPayApi.seller.startShipment(option.shipment.id).then(() => {
          this.show(false);
          this.$emit("success");
        }).catch(err => this.toast("Error updating contract: " + err));
      }
      else if (this.modalType !== "add") {
        trackPayApi.seller.updateContract(option).then(() => {
          this.show(false);
          this.$emit("success");
        }).catch(err => this.toast("Error updating contract: " + err));
      } else if (type === 'saveAndSend') {
        trackPayApi.seller.createContractAndSendToDebtor(option).then(() => {
          this.show(false);
          this.$emit("success");
        }).catch(err => this.toast("Error creating contract: " + err));
      } else {
        trackPayApi.seller.createContract(option).then(() => {
          this.show(false);
          this.$emit("success");
        }).catch(err => this.toast(err));
      }
    },
    show(value) {
      this.shown = value;
    },
    showRelationModal() {
      this.show(true);
      this.modalType = "add";
      this.readOnly = false;
      this.activeType = this.activeTypes.salesContract;
      this.contractData = {};

      if (this.modalType !== "startShipment") {
        this.$nextTick(() => {
          this.$refs.ShipmentForm.form = {
            ...this.$refs.ShipmentForm.form
          };
          this.$refs.SalesContractForm.form = {
            ...this.$refs.SalesContractForm.form
          };
          this.$refs.TrackersForm.form = {
            ...this.$refs.TrackersForm.form
          };
          this.$refs.Process.form = {
            ...this.$refs.ShipmentForm.form,
            ...this.$refs.SalesContractForm.form,
            ...this.$refs.TrackersForm.form}
          if (!this.$refs.ShipmentForm.form.shipment.fromAddress.companyName || this.$refs.ShipmentForm.form.shipment.fromAddress.companyName === '') {
            let localeUser = this.$sessionStorage.get("localeUser");
            this.$refs.ShipmentForm.form.shipment.fromAddress.companyName = localeUser.companyName;
          }
        });
      }
    },
    showDetail(data) {
      trackPayApi.seller.getContract(data.data.id).then((res) => {
        this.show(true);
        this.modalType = data.btnType;
        this.readOnly = false;
        this.activeType = data.activeType || this.activeTypes.salesContract;
        this.contractData = res;

        if (this.modalType === "viewDetail") {
          this.readOnly = true;
        }
        if (this.modalType === "sendToCustomer") {
          this.changeActiveType(this.activeTypes.process);
        }
        if (this.modalType !== "startShipment") {
          this.$nextTick(() => {
            this.$refs.ShipmentForm.form = {
              ...this.$refs.ShipmentForm.form,
              ...this.contractData.shipment,
            };
            this.$refs.SalesContractForm.form = {
              ...this.$refs.SalesContractForm.form,
              ...this.contractData
            };
            this.$refs.TrackersForm.form = {
              ...this.$refs.TrackersForm.form
            };
          });
        }
      }).catch(this.toast);
    },
    changeActiveType(type) {
      this.activeType = type;
      if (this.activeType === this.activeTypes.trackers) {
        this.$refs.TrackersForm.loadTrackerDevices(this.$refs.ShipmentForm.form.shipment.productGroupId, this.$refs.ShipmentForm.form.modesOfTransport);
      }
    }
  }
};
</script>
<style lang="scss">
  .rejected_box {
    width: calc(100% - 40px);
    margin: 10px auto;
    text-align: left;
    border: 1px solid #f43728;
    padding: 10px;
    border-radius: 8px;
    .reason_text {
      overflow: auto;
      max-height: 50px;
      // height: 50px;
    }
  }
  .has_reason {
    .modal-content.modal-content--in-group {
      max-height: calc(100vh - 340px);
    }
  }
</style>